import { Injectable } from '@angular/core';

import { ESRI } from '../esri-loader-util';

import { MapService } from './map.service';

interface IScalebarOptions {
    position?: 'bottom-leading' | 'bottom-left' | 'bottom-right' | 'bottom-trailing' | 'top-leading' | 'top-left' | 'top-right' | 'top-trailing' | 'manual';
    style?: 'ruler' | 'line';
    unit?: 'non-metric' | 'metric' | 'dual';
    index?: number;
}

@Injectable({
    providedIn: 'root'
})
export class ScalebarService {
    private scaleBarConstructor: __esri.ScaleBarConstructor;
    private scalebar: __esri.ScaleBar;

    public get Scalebar(): __esri.ScaleBar {
        return this.scalebar;
    }

    constructor(private readonly mapService: MapService) { }

    public async showScalebar(show: boolean = true, options?: IScalebarOptions) {
        if (this.scaleBarConstructor == null) {
            this.scaleBarConstructor = await ESRI.ScaleBarWidget;
        }

        if (this.scalebar == null) {
            this.scalebar = new this.scaleBarConstructor({
                view: this.mapService.mcMapView,
                unit: options.unit,
                style: options.style
            });

            this.mapService.mcMapView.ui.add(this.scalebar, { position: options.position });
        }

        this.scalebar.visible = show;
    }

    public removeScalebar() {
        if (this.scalebar) {
            this.mapService.mcMapView.ui.remove(this.scalebar);
            this.scalebar = null;
        }
    }
}
